import axios  from "axios"

export default {
    //  data: can be email or mobile number with country code without +
    // type : type to send otp : email or mobile
    async sendForgotPasswordOTP(type, data){
        try{
            const res = await axios.post('/user/forgot-password/'+type, data);
            return Promise.resolve(res.data);

        } catch(e)  {
            return Promise.reject(e);
        }
    },

    async verifyForgPasswordOTP(data) {
        try{
            const res = await axios.post('/user/verify-otp/forgot-password', data);
            return Promise.resolve(res.data);

        } catch(e)  {
            return Promise.reject(e);
        }
    },

    async createNewPassword(authToken, data) {
        try{
            const res = await axios.post('/user/create-password', data, {
                headers: {
                    'oauth-token': authToken
                }
            });
            return Promise.resolve(res.data);

        } catch(e)  {
            return Promise.reject(e);
        }
    }

}